const listaDeUsuariosApis = (state) => {
    return state.items;
}

const loadingUsuarioApi = (state) => {
    return state.carregando
}

export {
    listaDeUsuariosApis,
    loadingUsuarioApi
}